import React, { useContext } from 'react';
import TemplateCard from '../TemplateCard/TemplateCard.component';
import { TemplateLibraryContext, TemplateLibraryContextType } from '../TemplateLibrary/TemplateLibrary.context';
import './MergeFloTemplates.component.scss';

export interface MergeFloTemplatesProps {

}

const MergeFloTemplates = ({

}: MergeFloTemplatesProps) => {
  const { 
    onChangeTemplateCardCheck,
    templateLibraries = [],
  } = useContext(TemplateLibraryContext) as TemplateLibraryContextType;
  return (
    <div className="template-library-list">
      {
        templateLibraries.map(item => (
          <TemplateCard
            key={item.templateId}
            temp={item}
            onChange={onChangeTemplateCardCheck}
          />
        ))
      }
    </div>
  )
}

export default MergeFloTemplates;
